import React from 'react'
import Head from 'next/head'
import dynamic from 'next/dynamic'
import { GetServerSideProps, GetServerSidePropsContext } from 'next'
import { HomeContainer } from '../../../styles/pages/home'
import { getPostsByTag } from '../../../services/posts'
import { Post } from '../../../types/post'

const PostCard = dynamic(() => import('../../../components/postCard'))

type HomeProps = {
  posts: Post[]
}

const Home: React.FC<HomeProps> = ({ posts }) => {
  return (
    <HomeContainer>
      <Head>
        <title>Ricardo Borges</title>
      </Head>
      {posts.map(post => (
        <PostCard key={post.id} post={post} />
      ))}
    </HomeContainer>
  )
}

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  try {
    const posts = await getPostsByTag(context.params.tag as string)
    return {
      props: { posts }
    }
  } catch (err) {
    console.error(err)
    return {
      props: { posts: [] }
    }
  }
}

export default Home
